module.exports = __webpack_public_path__ + "images/花筑院子全景_08-1.jpg?v=e63dbb49";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_08-1.jpg
 ** module id = 81
 ** module chunks = 1 2
 **/